import apiV2 from "api-v2";
import { unwrap } from "newui/utils/apiResponse";
import type {
	RfxNotificationManagementResource,
	RfxNotificationRulesWriteRequest,
} from "../types/rfx-notification-mgmt.types";

// VT-010: apiV2 has no unwrap response interceptor — Laravel API Resources
// arrive as the raw `{ data: ... }` envelope. This previously returned that
// envelope directly, so callers' `data.coverage`/`.rules`/`.participants`
// were all undefined, throwing in RfxNotificationMgmtPage's `typeKeys` memo
// before the page ever rendered. Unwrap here, matching notifications-api.ts
// and rbac-api.ts's convention.
export const getRfxNotificationManagement = async (
	rfxId: number
): Promise<RfxNotificationManagementResource> => {
	const { data } = await apiV2.get(`rfx/${rfxId}/notification-management`);
	return unwrap<RfxNotificationManagementResource>(data);
};

// C17: the write can legitimately resolve to a 422 (static forbid) or 409
// (dynamic coverage reduction) — both are expected, caller-handled outcomes,
// not unexpected errors, so the global toast interceptor is silenced for them.
export const putRfxNotificationRules = async (
	rfxId: number,
	payload: RfxNotificationRulesWriteRequest
): Promise<RfxNotificationManagementResource> => {
	const { data } = await apiV2.put(`rfx/${rfxId}/notification-management/rules`, payload, {
		expectedErrors: [409, 422],
	} as Record<string, unknown>);
	return unwrap<RfxNotificationManagementResource>(data);
};
